import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryDisplayItem } from 'src/app/models/deliveries/delivery-display-item';
import { CompactPotentialDeliverableItem } from './deliverable-service.interface';

@Pipe({
  name: 'deliverableItemList',
  standalone: true
})
export class DeliverableItemListPipe implements PipeTransform {
  transform(
    itemIds: number[],
    potentialItems: CompactPotentialDeliverableItem[]
  ): string {
    if (!itemIds || itemIds.length === 0) {
      return '';
    }

    return itemIds
      .filter((itemId) =>
        potentialItems.find((item) => item.deliverable_item_id === itemId)
      )
      .map(
        (itemId) =>
          potentialItems.find((item) => item.deliverable_item_id === itemId)
            ?.description
      )
      .join(', ');
  }
}
